import React from "react";
import "./style.css";
import { lifeAtBitsclanData } from "../../data/lifeAtBitsclanData";
import { useTranslation } from "react-i18next";

const CeoIntro = () => {
  const { t } = useTranslation("lifeAtBitsclan");

  // Get translated projects array
  const ceoIntro = t("ceoIntro", { returnObjects: true });
  return (
    <>
      {/* <div className="ceo-intro-main-box meet-our-team-box">
        <div className="container">
          <div className="row">
            <div className="col-xl-5 col-lg-5 col-md-6">
              <div className="ceo-image">
                <img src="images/life-at-bitsclan/ceo.svg" alt="CEO Image" />
              </div>
            </div>

            <div className="col-xl-7 col-lg-7 col-md-6 ps-xl-5 ps-lg-5 mt-4 mt-lg-0">
              <div className="intro-text">
                <h1 class="main-heading">
                  {ceoIntro.heading}
                </h1>
                <p>{ceoIntro.subHeading}</p>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <section className="life-at-bitsclan-ceo-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-4">
              <div className="life-at-bitsclan-ceo-image-card">
                <div className="life-at-bitsclan-ceo-image-frame">
                  <img src="/images/life-at-bitsclan/ceo-awais.avif" alt="Furqan Aziz" className="img-fluid life-at-bitsclan-ceo-image" />
                </div>
                <div className="life-at-bitsclan-ceo-details text-center">
                  {/* <h4 className="text-white">Awais Sarwar</h4>
                  <p className="mb-3 mt-2 text-white">CEO of Bitsclan</p> */}
                  <div className="life-at-bitsclan-ceo-social-icons">
                    {/* <a href="#"><i class="fa-brands fa-linkedin"></i></a> */}
                    {/* <a href="#"><i class="fa-brands fa-x-twitter"></i></a> */}
                    {/* <a href="#"><i class="fa-solid fa-envelope"></i></a> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-8 ps-xl-5 ps-lg-5">
              <div className="life-at-bitsclan-ceo-message">
                <h2 className="mb-4">Message From Our <span>CEO</span> (Awais Sarwar)</h2>
                {/* <p>Hey Everyone,</p> */}
                {/* <p>Welcome to Bitsclan. I’m <strong>Awais Sarwar</strong> CEO of this passionate tech company.</p> */}
                <p className="text-white">At Bitsclan, we specialize in web, mobile, & AI solutions that drive growth & innovation. Our mission is simple deliver technology that solves real problems, builds lasting partnerships, & empowers businesses to thrive.</p>
                <p className="text-white">With integrity, transparency, & innovation at our core, we’re here to shape the digital future together.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CeoIntro;
